import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CommentIcon from '@material-ui/icons/Comment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

import moment from 'moment';
import _ from 'lodash';

import PieChartAnalytics from '../containers/PieChartAnalytics';

const styles = theme => ({
  paperPieChart: {
    color: theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
    padding: '15px',
    marginTop: '8px',
  },
  paperAdsComment: {
    color: theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
    padding: '15px',
    margin: '5px',
    width: '392.42px',
    height: '250px',
    overflow: 'auto',
  },
  questionTitle: {
    ...theme.Typography,
    color: '#044591',
    textAlign: 'center',
  },
  pieContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '5px',
  },
  headerQuestionTitle: {
    display: 'flex',
    color: '#044591',
    marginTop: '15px',
    justifyContent: 'center',
  },
  headerQuestionIcon: {
    marginRight: '15px',
  },
  chartTitle: {
    ...theme.Typography,
    color: '#044591',
  },
  inlineComment: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  dateComment: {
    color: 'gray',
    paddingLeft: '5px',
  },
  userComment: {
    fontWeight: 'bold',
  },
  adsContainer: {
    justifyContent: 'space-evenly',
    alignItems: 'center',
    height: '100%',
  },
  adsData: {
    height: '100%',
    justifyContent: 'space-around',
    display: 'flex',
    flexDirection: 'column',
  },
});

const Comment = ({ classes, question }) => {
  const { questionTitle, listComments } = question;
  const listCommentsSize = _.get(listComments, 'length', 0);

  return (
    <Grid item className={classes.pieContainer}>
      <Paper className={classes.paperAdsComment}>
        <div className={classes.headerQuestionTitle}>
          <CommentIcon className={classes.headerQuestionIcon} />
          <Typography variant="subtitle2" className={classes.chartTitle}>
            {questionTitle}
          </Typography>
        </div>
        <List className={classes.root}>
          {listComments.map((comm, idx) => {
            const dataFormatted = moment(comm.date).format('hh:mm A - YYYY/MM/DD');
            return (
              <div key={idx}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={
                      <div className={classes.inlineComment}>
                        <Typography
                          variant="subtitle1"
                          color="textPrimary"
                          fontWeight="fontWeightBold"
                          className={classes.userComment}
                        >
                          {comm.userName}
                        </Typography>
                        <Typography
                          variant="caption"
                          className={classes.dateComment}
                          gutterBottom
                        >
                          {dataFormatted}
                        </Typography>
                      </div>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography component="span" variant="body2" color="textPrimary">
                          {comm.comment}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                {idx < listCommentsSize - 1 && <Divider component="li" />}
              </div>
            );
          })}
        </List>
      </Paper>
    </Grid>
  );
};

const Ads = ({ classes, question }) => {
  const { questionTitle, totalViews, totalClicks, rateViews, rateClicks } = question;

  return (
    <Grid item className={classes.pieContainer}>
      <Paper className={classes.paperAdsComment}>
        <div className={classes.headerQuestionTitle}>
          <MonetizationOnIcon className={classes.headerQuestionIcon} />
          <Typography variant="subtitle2" className={classes.chartTitle}>
            {questionTitle}
          </Typography>
        </div>
        <Grid container spacing={1} className={classes.adsContainer}>
          <Grid item className={classes.adsData}>
            <AdsData classes={classes} number={totalViews} text={'total views'} />
            <AdsData classes={classes} number={rateViews + '%'} text={'rate views'} />
          </Grid>
          <Grid item className={classes.adsData}>
            <AdsData classes={classes} number={totalClicks} text={'total clicks'} />
            <AdsData classes={classes} number={rateClicks + '%'} text={'rate clicks'} />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

const AdsData = ({ classes, number, text }) => {
  return (
    <div>
      <div style={{ textAlign: 'center' }}>
        <Typography variant="h5">{number}</Typography>
      </div>
      <div>{text}</div>
    </div>
  );
};

class Questions extends React.Component {
  render() {
    const { classes, title, data, filter } = this.props;

    return (
      <Paper className={classes.paperPieChart} elevation={0}>
        <Typography variant="subtitle1" className={classes.questionTitle}>
          {title}
        </Typography>
        <Grid container spacing={1}>
          {data.map((question, index) => {
            if (question.questionHasData) {
              const pieChart = (
                <PieChartAnalytics question={question} key={index} filter={filter} />
              );
              const commentContent = (
                <Comment classes={classes} question={question} key={index} />
              );
              const adsContent = (
                <Ads classes={classes} question={question} key={index} />
              );
              if (question.type === 'defaultQuestion') {
                return pieChart;
              } else if (question.type === 'comment') {
                return commentContent;
              } else if (question.type === 'ads') {
                return adsContent;
              }
            }

            return null;
          })}
        </Grid>
      </Paper>
    );
  }
}

export default withStyles(styles)(Questions);
